import { Button, Card, Flex, Form, Input, Modal, Space } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';

function ResetPassDesktop({ viewModel }) {
  const {
    token,
    form,
    otpForm,
    navigate,
    isShowOtp,
    setIshowOpt,
    handleCreate,
    onFinish,
    onOtpFinish,
  } = viewModel;

  return (
    <Card style={{ width: '500px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
      <Flex vertical gap={14}>
        <Space direction="vertical" style={{ textAlign: 'center' }}>
          <img alt="sipro-logo" width={200} style={{ borderRadius: '8px' }} src="https://storage.googleapis.com/cubebio/default/siprologo.png" />
          <span style={{ fontSize: token.fontSizeHeading3, fontWeight: '500' }}>Đặt lại mật khẩu</span>
        </Space>

        <Form layout="vertical" form={form} initialValues={{}} onFinish={onFinish}>
          <Form.Item
            label="Số điện thoại"
            name="phone"
            rules={[{ required: true, pattern: /^[0-9]{10}$/, message: 'Số điện thoại không đúng định dạng' }]}
          >
            <Input placeholder="Phone"></Input>
          </Form.Item>

          <Form.Item label="Password" name="pass" rules={[{ required: true }]}>
            <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Form.Item
            label="RePassword"
            name="re_pass"
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('pass') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('The two passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Password" iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
          </Form.Item>

          <Space direction="vertical" style={{ width: '100%' }} size={'large'}>
            <Button type="primary" style={{ width: '100%' }} onClick={handleCreate}>
              Đặt lại
            </Button>

            <Flex align="center" justify="center">
              <span>Already have an account?</span>
              <Button type="link" onClick={() => navigate('/login')}>
                Login
              </Button>
            </Flex>
          </Space>
        </Form>
      </Flex>

      <Modal
        title="Xác nhận otp"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isShowOtp}
        onOk={() => otpForm.submit()}
        onCancel={() => setIshowOpt(false)}
        onClose={() => setIshowOpt(false)}
        okText="Xác nhận"
      >
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <Form layout="vertical" form={otpForm} initialValues={{}} onFinish={onOtpFinish} style={{ width: 300 }}>
            <Form.Item
              label="OTP"
              name="otp"
              rules={[
                { required: true },
                { pattern: /^[0-9]{4}$/, message: 'OTP must be a 4-digit number' },
              ]}
            >
              <Input.OTP length={4} style={{ width: '100%' }} />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </Card>
  );
}

export default ResetPassDesktop;
